var _excluded = ["a11yTitle"],
  _excluded2 = ["size", "variant", "colorScheme", "disabled", "onClick", "children", "LeftIcon", "RightIcon", "tabIndex", "fit", "name", "value", "className", "type", "waitingOptions", "wait", "adaptive"],
  _excluded3 = ["apiUrl", "LeftIcon", "SpinnerIcon", "onClick", "onError", "onFinishLoad", "fit", "variant", "colorScheme", "size", "children", "waitingOptions"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { jsx as m, jsxs as ui } from "react/jsx-runtime";
import { forwardRef as Oi, useMemo as Ci, useState as Li, useCallback as Ti } from "react";
import { createGlobalStyle as _i, styled as H, css as S } from "styled-components";
var me = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
var ke = {
    exports: {}
  },
  zi = ke.exports,
  Xe;
function Hi() {
  return Xe || (Xe = 1, function (e, i) {
    (function (r, d) {
      d();
    })(zi, function () {
      function r(c, p) {
        return typeof p > "u" ? p = {
          autoBom: !1
        } : typeof p != "object" && (console.warn("Deprecated: Expected third argument to be a object"), p = {
          autoBom: !p
        }), p.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(c.type) ? new Blob(["\uFEFF", c], {
          type: c.type
        }) : c;
      }
      function d(c, p, y) {
        var g = new XMLHttpRequest();
        g.open("GET", c), g.responseType = "blob", g.onload = function () {
          b(g.response, p, y);
        }, g.onerror = function () {
          console.error("could not download file");
        }, g.send();
      }
      function f(c) {
        var p = new XMLHttpRequest();
        p.open("HEAD", c, !1);
        try {
          p.send();
        } catch (_unused) {}
        return 200 <= p.status && 299 >= p.status;
      }
      function u(c) {
        try {
          c.dispatchEvent(new MouseEvent("click"));
        } catch (_unused2) {
          var p = document.createEvent("MouseEvents");
          p.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), c.dispatchEvent(p);
        }
      }
      var l = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof me == "object" && me.global === me ? me : void 0,
        w = l.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent),
        b = l.saveAs || (typeof window != "object" || window !== l ? function () {} : "download" in HTMLAnchorElement.prototype && !w ? function (c, p, y) {
          var g = l.URL || l.webkitURL,
            v = document.createElement("a");
          p = p || c.name || "download", v.download = p, v.rel = "noopener", typeof c == "string" ? (v.href = c, v.origin === location.origin ? u(v) : f(v.href) ? d(c, p, y) : u(v, v.target = "_blank")) : (v.href = g.createObjectURL(c), setTimeout(function () {
            g.revokeObjectURL(v.href);
          }, 4e4), setTimeout(function () {
            u(v);
          }, 0));
        } : "msSaveOrOpenBlob" in navigator ? function (c, p, y) {
          if (p = p || c.name || "download", typeof c != "string") navigator.msSaveOrOpenBlob(r(c, y), p);else if (f(c)) d(c, p, y);else {
            var g = document.createElement("a");
            g.href = c, g.target = "_blank", setTimeout(function () {
              u(g);
            });
          }
        } : function (c, p, y, g) {
          if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), typeof c == "string") return d(c, p, y);
          var v = c.type === "application/octet-stream",
            P = /constructor/i.test(l.HTMLElement) || l.safari,
            C = /CriOS\/[\d]+/.test(navigator.userAgent);
          if ((C || v && P || w) && typeof FileReader < "u") {
            var L = new FileReader();
            L.onloadend = function () {
              var T = L.result;
              T = C ? T : T.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = T : location = T, g = null;
            }, L.readAsDataURL(c);
          } else {
            var j = l.URL || l.webkitURL,
              I = j.createObjectURL(c);
            g ? g.location = I : location.href = I, g = null, setTimeout(function () {
              j.revokeObjectURL(I);
            }, 4e4);
          }
        });
      l.saveAs = b.saveAs = b, e.exports = b;
    });
  }(ke)), ke.exports;
}
var Ii = Hi(),
  Mi = "2.0.3",
  Ue = 500,
  Ye = "user-agent",
  te = "",
  Ke = "?",
  Re = "function",
  W = "undefined",
  oe = "object",
  Ne = "string",
  R = "browser",
  F = "cpu",
  D = "device",
  M = "engine",
  z = "os",
  ee = "result",
  n = "name",
  t = "type",
  a = "vendor",
  s = "version",
  E = "architecture",
  we = "major",
  o = "model",
  ue = "console",
  h = "mobile",
  x = "tablet",
  k = "smarttv",
  B = "wearable",
  Le = "xr",
  pe = "embedded",
  re = "inapp",
  qe = "brands",
  K = "formFactors",
  Ve = "fullVersionList",
  ie = "platform",
  Ge = "platformVersion",
  Ae = "bitness",
  X = "sec-ch-ua",
  Pi = X + "-full-version-list",
  Bi = X + "-arch",
  Di = X + "-" + Ae,
  Fi = X + "-form-factors",
  Ui = X + "-" + h,
  Ni = X + "-" + o,
  pi = X + "-" + ie,
  $i = pi + "-version",
  hi = [qe, Ve, h, o, ie, Ge, E, K, Ae],
  xe = "Amazon",
  J = "Apple",
  Ze = "ASUS",
  Je = "BlackBerry",
  Y = "Google",
  Qe = "Huawei",
  ei = "Lenovo",
  ii = "Honor",
  ye = "LG",
  Te = "Microsoft",
  _e = "Motorola",
  ze = "Nvidia",
  ti = "OnePlus",
  He = "OPPO",
  se = "Samsung",
  oi = "Sharp",
  le = "Sony",
  Ie = "Xiaomi",
  Me = "Zebra",
  ai = "Chrome",
  ni = "Chromium",
  q = "Chromecast",
  ji = "Edge",
  fe = "Firefox",
  de = "Opera",
  Pe = "Facebook",
  ri = "Sogou",
  Q = "Mobile ",
  ce = " Browser",
  $e = "Windows",
  qi = typeof window !== W,
  A = qi && window.navigator ? window.navigator : void 0,
  V = A && A.userAgentData ? A.userAgentData : void 0,
  Vi = function Vi(e, i) {
    var r = {},
      d = i;
    if (!Ee(i)) {
      d = {};
      for (var f in i) {
        for (var u in i[f]) {
          d[u] = i[f][u].concat(d[u] ? d[u] : []);
        }
      }
    }
    for (var l in e) {
      r[l] = d[l] && d[l].length % 2 === 0 ? d[l].concat(e[l]) : e[l];
    }
    return r;
  },
  Oe = function Oe(e) {
    for (var i = {}, r = 0; r < e.length; r++) {
      i[e[r].toUpperCase()] = e[r];
    }
    return i;
  },
  je = function je(e, i) {
    if (typeof e === oe && e.length > 0) {
      for (var r in e) {
        if (U(e[r]) == U(i)) return !0;
      }
      return !1;
    }
    return ne(e) ? U(i).indexOf(U(e)) !== -1 : !1;
  },
  Ee = function Ee(e, i) {
    for (var r in e) {
      return /^(browser|cpu|device|engine|os)$/.test(r) || (i ? Ee(e[r]) : !1);
    }
  },
  ne = function ne(e) {
    return typeof e === Ne;
  },
  Be = function Be(e) {
    if (e) {
      for (var i = [], r = ae(/\\?\"/g, e).split(","), d = 0; d < r.length; d++) {
        if (r[d].indexOf(";") > -1) {
          var f = ge(r[d]).split(";v=");
          i[d] = {
            brand: f[0],
            version: f[1]
          };
        } else i[d] = ge(r[d]);
      }
      return i;
    }
  },
  U = function U(e) {
    return ne(e) ? e.toLowerCase() : e;
  },
  De = function De(e) {
    return ne(e) ? ae(/[^\d\.]/g, e).split(".")[0] : void 0;
  },
  N = function N(e) {
    for (var i in e) {
      var r = e[i];
      typeof r == oe && r.length == 2 ? this[r[0]] = r[1] : this[r] = void 0;
    }
    return this;
  },
  ae = function ae(e, i) {
    return ne(i) ? i.replace(e, te) : i;
  },
  be = function be(e) {
    return ae(/\\?\"/g, e);
  },
  ge = function ge(e, i) {
    if (ne(e)) return e = ae(/^\s\s*/, e), typeof i === W ? e : e.substring(0, Ue);
  },
  Fe = function Fe(e, i) {
    if (!(!e || !i)) for (var r = 0, d, f, u, l, w, b; r < i.length && !w;) {
      var c = i[r],
        p = i[r + 1];
      for (d = f = 0; d < c.length && !w && c[d];) {
        if (w = c[d++].exec(e), w) for (u = 0; u < p.length; u++) {
          b = w[++f], l = p[u], typeof l === oe && l.length > 0 ? l.length === 2 ? typeof l[1] == Re ? this[l[0]] = l[1].call(this, b) : this[l[0]] = l[1] : l.length === 3 ? typeof l[1] === Re && !(l[1].exec && l[1].test) ? this[l[0]] = b ? l[1].call(this, b, l[2]) : void 0 : this[l[0]] = b ? b.replace(l[1], l[2]) : void 0 : l.length === 4 && (this[l[0]] = b ? l[3].call(this, b.replace(l[1], l[2])) : void 0) : this[l] = b || void 0;
        }
      }
      r += 2;
    }
  },
  G = function G(e, i) {
    for (var r in i) {
      if (typeof i[r] === oe && i[r].length > 0) {
        for (var d = 0; d < i[r].length; d++) {
          if (je(i[r][d], e)) return r === Ke ? void 0 : r;
        }
      } else if (je(i[r], e)) return r === Ke ? void 0 : r;
    }
    return i.hasOwnProperty("*") ? i["*"] : e;
  },
  si = {
    ME: "4.90",
    "NT 3.11": "NT3.51",
    "NT 4.0": "NT4.0",
    2e3: "NT 5.0",
    XP: ["NT 5.1", "NT 5.2"],
    Vista: "NT 6.0",
    7: "NT 6.1",
    8: "NT 6.2",
    "8.1": "NT 6.3",
    10: ["NT 6.4", "NT 10.0"],
    RT: "ARM"
  },
  li = {
    embedded: "Automotive",
    mobile: "Mobile",
    tablet: ["Tablet", "EInk"],
    smarttv: "TV",
    wearable: "Watch",
    xr: ["VR", "XR"],
    "?": ["Desktop", "Unknown"],
    "*": void 0
  },
  fi = {
    browser: [[
    // Most common regardless engine
    /\b(?:crmo|crios)\/([\w\.]+)/i
    // Chrome for Android/iOS
    ], [s, [n, Q + "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i
    // Microsoft Edge
    ], [s, [n, "Edge"]], [
    // Presto based
    /(opera mini)\/([-\w\.]+)/i,
    // Opera Mini
    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
    // Opera Mobi/Tablet
    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
    // Opera
    ], [n, s], [/opios[\/ ]+([\w\.]+)/i
    // Opera mini on iphone >= 8.0
    ], [s, [n, de + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i
    // Opera GX
    ], [s, [n, de + " GX"]], [/\bopr\/([\w\.]+)/i
    // Opera Webkit
    ], [s, [n, de]], [
    // Mixed
    /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
    // Baidu
    ], [s, [n, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
    // Maxthon
    ], [s, [n, "Maxthon"]], [/(kindle)\/([\w\.]+)/i,
    // Kindle
    /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
    // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
    // Trident based
    /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
    // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
    /(?:ms|\()(ie) ([\w\.]+)/i,
    // Internet Explorer
    // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon/LG Browser/Otter/qutebrowser/Dooble
    /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser)\/([-\w\.]+)/i,
    // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
    /(heytap|ovi|115|surf)browser\/([\d\.]+)/i,
    // HeyTap/Ovi/115/Surf
    /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
    // Ecosia/Weibo
    ], [n, s], [/quark(?:pc)?\/([-\w\.]+)/i
    // Quark
    ], [s, [n, "Quark"]], [/\bddg\/([\w\.]+)/i
    // DuckDuckGo
    ], [s, [n, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
    // UCBrowser
    ], [s, [n, "UCBrowser"]], [/microm.+\bqbcore\/([\w\.]+)/i,
    // WeChat Desktop for Windows Built-in Browser
    /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i
    // WeChat
    ], [s, [n, "WeChat"]], [/konqueror\/([\w\.]+)/i
    // Konqueror
    ], [s, [n, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
    // IE11
    ], [s, [n, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i
    // Yandex
    ], [s, [n, "Yandex"]], [/slbrowser\/([\w\.]+)/i
    // Smart Lenovo Browser
    ], [s, [n, "Smart " + ei + ce]], [/(avast|avg)\/([\w\.]+)/i
    // Avast/AVG Secure Browser
    ], [[n, /(.+)/, "$1 Secure" + ce], s], [/\bfocus\/([\w\.]+)/i
    // Firefox Focus
    ], [s, [n, fe + " Focus"]], [/\bopt\/([\w\.]+)/i
    // Opera Touch
    ], [s, [n, de + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i
    // Coc Coc Browser
    ], [s, [n, "Coc Coc"]], [/dolfin\/([\w\.]+)/i
    // Dolphin
    ], [s, [n, "Dolphin"]], [/coast\/([\w\.]+)/i
    // Opera Coast
    ], [s, [n, de + " Coast"]], [/miuibrowser\/([\w\.]+)/i
    // MIUI Browser
    ], [s, [n, "MIUI" + ce]], [/fxios\/([\w\.-]+)/i
    // Firefox for iOS
    ], [s, [n, Q + fe]], [/\bqihoobrowser\/?([\w\.]*)/i
    // 360
    ], [s, [n, "360"]], [/\b(qq)\/([\w\.]+)/i
    // QQ
    ], [[n, /(.+)/, "$1Browser"], s], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[n, /(.+)/, "$1" + ce], s], [
    // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
    /samsungbrowser\/([\w\.]+)/i
    // Samsung Internet
    ], [s, [n, se + " Internet"]], [/metasr[\/ ]?([\d\.]+)/i
    // Sogou Explorer
    ], [s, [n, ri + " Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i
    // Sogou Mobile
    ], [[n, ri + " Mobile"], s], [/(electron)\/([\w\.]+) safari/i,
    // Electron-based App
    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
    // Tesla
    /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
    // QQ/2345
    ], [n, s], [/(lbbrowser|rekonq)/i
    // LieBao Browser/Rekonq
    ], [n], [/ome\/([\w\.]+) \w* ?(iron) saf/i,
    // Iron
    /ome\/([\w\.]+).+qihu (360)[es]e/i
    // 360
    ], [s, n], [
    // WebView
    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
    // Facebook App for iOS & Android
    ], [[n, Pe], s, [t, re]], [/(Klarna)\/([\w\.]+)/i,
    // Klarna Shopping Browser for iOS & Android
    /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
    // Kakao App
    /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
    // Naver InApp
    /(daum)apps[\/ ]([\w\.]+)/i,
    // Daum App
    /safari (line)\/([\w\.]+)/i,
    // Line App for iOS
    /\b(line)\/([\w\.]+)\/iab/i,
    // Line App for Android
    /(alipay)client\/([\w\.]+)/i,
    // Alipay
    /(twitter)(?:and| f.+e\/([\w\.]+))/i,
    // Twitter
    /(instagram|snapchat)[\/ ]([-\w\.]+)/i
    // Instagram/Snapchat
    ], [n, s, [t, re]], [/\bgsa\/([\w\.]+) .*safari\//i
    // Google Search Appliance on iOS
    ], [s, [n, "GSA"], [t, re]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
    // TikTok
    ], [s, [n, "TikTok"], [t, re]], [/\[(linkedin)app\]/i
    // LinkedIn App for iOS & Android
    ], [n, [t, re]], [/(chromium)[\/ ]([-\w\.]+)/i
    // Chromium
    ], [n, s], [/headlesschrome(?:\/([\w\.]+)| )/i
    // Chrome Headless
    ], [s, [n, ai + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i
    // Chrome WebView
    ], [[n, ai + " WebView"], s], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
    // Android Browser
    ], [s, [n, "Android" + ce]], [/chrome\/([\w\.]+) mobile/i
    // Chrome Mobile
    ], [s, [n, Q + "Chrome"]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
    // Chrome/OmniWeb/Arora/Tizen/Nokia
    ], [n, s], [/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
    // Safari Mobile
    ], [s, [n, Q + "Safari"]], [/iphone .*mobile(?:\/\w+ | ?)safari/i], [[n, Q + "Safari"]], [/version\/([\w\.\,]+) .*(safari)/i
    // Safari
    ], [s, n], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
    // Safari < 3.0
    ], [n, [s, "1"]], [/(webkit|khtml)\/([\w\.]+)/i], [n, s], [
    // Gecko based
    /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
    // Firefox Mobile
    ], [[n, Q + fe], s], [/(navigator|netscape\d?)\/([-\w\.]+)/i
    // Netscape
    ], [[n, "Netscape"], s], [/(wolvic|librewolf)\/([\w\.]+)/i
    // Wolvic/LibreWolf
    ], [n, s], [/mobile vr; rv:([\w\.]+)\).+firefox/i
    // Firefox Reality
    ], [s, [n, fe + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i,
    // Flow
    /(swiftfox)/i,
    // Swiftfox
    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
    // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
    // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
    /(firefox)\/([\w\.]+)/i,
    // Other Firefox-based
    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
    // Mozilla
    // Other
    /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
    // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
    /\b(links) \(([\w\.]+)/i
    // Links
    ], [n, [s, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i
    // Cobalt
    ], [n, [s, /[^\d\.]+./, te]]],
    cpu: [[/\b((amd|x|x86[-_]?|wow|win)64)\b/i
    // AMD64 (x64)
    ], [[E, "amd64"]], [/(ia32(?=;))/i,
    // IA32 (quicktime)
    /\b((i[346]|x)86)(pc)?\b/i
    // IA32 (x86)
    ], [[E, "ia32"]], [/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
    // ARM64
    ], [[E, "arm64"]], [/\b(arm(v[67])?ht?n?[fl]p?)\b/i
    // ARMHF
    ], [[E, "armhf"]], [
    // PocketPC mistakenly identified as PowerPC
    /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i], [[E, "arm"]], [/((ppc|powerpc)(64)?)( mac|;|\))/i
    // PowerPC
    ], [[E, /ower/, te, U]], [/ sun4\w[;\)]/i
    // SPARC
    ], [[E, "sparc"]], [/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
    // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ], [[E, U]]],
    device: [[
    //////////////////////////
    // MOBILES & TABLETS
    /////////////////////////
    // Samsung
    /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [o, [a, se], [t, x]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [o, [a, se], [t, h]], [
    // Apple
    /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
    // iPod/iPhone
    ], [o, [a, J], [t, h]], [/\((ipad);[-\w\),; ]+apple/i,
    // iPad
    /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [o, [a, J], [t, x]], [/(macintosh);/i], [o, [a, J]], [
    // Sharp
    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [o, [a, oi], [t, h]], [
    // Honor
    /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i], [o, [a, ii], [t, x]], [/honor([-\w ]+)[;\)]/i], [o, [a, ii], [t, h]], [
    // Huawei
    /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i], [o, [a, Qe], [t, x]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [o, [a, Qe], [t, h]], [
    // Xiaomi
    /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i, /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
    // Mi Pad tablets
    ], [[o, /_/g, " "], [a, Ie], [t, x]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
    // Xiaomi POCO
    /\b; (\w+) build\/hm\1/i,
    // Xiaomi Hongmi 'numeric' models
    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
    // Xiaomi Hongmi
    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
    // Xiaomi Redmi
    /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
    // Xiaomi Redmi 'numeric' models
    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
    // Xiaomi Mi
    / ([\w ]+) miui\/v?\d/i], [[o, /_/g, " "], [a, Ie], [t, h]], [
    // OPPO
    /; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [o, [a, He], [t, h]], [/\b(opd2(\d{3}a?))(?: bui|\))/i], [o, [a, G, {
      OnePlus: ["304", "403", "203"],
      "*": He
    }], [t, x]], [
    // BLU Vivo Series
    /(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i], [o, [a, "BLU"], [t, h]], [
    // Vivo
    /; vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [o, [a, "Vivo"], [t, h]], [
    // Realme
    /\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [o, [a, "Realme"], [t, h]], [
    // Motorola
    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [o, [a, _e], [t, h]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [o, [a, _e], [t, x]], [
    // LG
    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [o, [a, ye], [t, x]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch))(\w+)/i, /\blg-?([\d\w]+) bui/i], [o, [a, ye], [t, h]], [
    // Lenovo
    /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i, /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i], [o, [a, ei], [t, x]], [
    // Nokia
    /(nokia) (t[12][01])/i], [a, o, [t, x]], [/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i, /nokia[-_ ]?(([-\w\. ]*))/i], [[o, /_/g, " "], [t, h], [a, "Nokia"]], [
    // Google
    /(pixel (c|tablet))\b/i
    // Google Pixel C/Tablet
    ], [o, [a, Y], [t, x]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
    // Google Pixel
    ], [o, [a, Y], [t, h]], [
    // Sony
    /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [o, [a, le], [t, h]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[o, "Xperia Tablet"], [a, le], [t, x]], [
    // OnePlus
    / (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [o, [a, ti], [t, h]], [
    // Amazon
    /(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
    // Kindle Fire without Silk / Echo Show
    /(kf[a-z]+)( bui|\)).+silk\//i
    // Kindle Fire HD
    ], [o, [a, xe], [t, x]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
    // Fire Phone
    ], [[o, /(.+)/g, "Fire Phone $1"], [a, xe], [t, h]], [
    // BlackBerry
    /(playbook);[-\w\),; ]+(rim)/i
    // BlackBerry PlayBook
    ], [o, a, [t, x]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i
    // BlackBerry 10
    ], [o, [a, Je], [t, h]], [
    // Asus
    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [o, [a, Ze], [t, x]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [o, [a, Ze], [t, h]], [
    // HTC
    /(nexus 9)/i
    // HTC Nexus 9
    ], [o, [a, "HTC"], [t, x]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
    // HTC
    // ZTE
    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
    // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ], [a, [o, /_/g, " "], [t, h]], [
    // TCL
    /tcl (xess p17aa)/i, /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i], [o, [a, "TCL"], [t, x]], [/droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i], [o, [a, "TCL"], [t, h]], [
    // itel
    /(itel) ((\w+))/i], [[a, U], o, [t, G, {
      tablet: ["p10001l", "w7001"],
      "*": "mobile"
    }]], [
    // Acer
    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [o, [a, "Acer"], [t, x]], [
    // Meizu
    /droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [o, [a, "Meizu"], [t, h]], [
    // Ulefone
    /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [o, [a, "Ulefone"], [t, h]], [
    // Energizer
    /; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [o, [a, "Energizer"], [t, h]], [
    // Cat
    /; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [o, [a, "Cat"], [t, h]], [
    // Smartfren
    /((?:new )?andromax[\w- ]+)(?: bui|\))/i], [o, [a, "Smartfren"], [t, h]], [
    // Nothing
    /droid.+; (a(?:015|06[35]|142p?))/i], [o, [a, "Nothing"], [t, h]], [
    // Archos
    /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i, /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i], [o, [a, "Archos"], [t, x]], [/archos ([\w ]+)( b|\))/i, /; (ac[3-6]\d\w{2,8})( b|\))/i], [o, [a, "Archos"], [t, h]], [
    // MIXED
    /(imo) (tab \w+)/i,
    // IMO
    /(infinix) (x1101b?)/i
    // Infinix XPad
    ], [a, o, [t, x]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
    // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
    /; (blu|hmd|imo|tcl)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
    // BLU/HMD/IMO/TCL
    /(hp) ([\w ]+\w)/i,
    // HP iPAQ
    /(microsoft); (lumia[\w ]+)/i,
    // Microsoft Lumia
    /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
    // Lenovo
    /(oppo) ?([\w ]+) bui/i
    // OPPO
    ], [a, o, [t, h]], [/(kobo)\s(ereader|touch)/i,
    // Kobo
    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
    // HP TouchPad
    /(kindle)\/([\w\.]+)/i
    // Kindle
    ], [a, o, [t, x]], [/(surface duo)/i
    // Surface Duo
    ], [o, [a, Te], [t, x]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i
    // Fairphone
    ], [o, [a, "Fairphone"], [t, h]], [/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
    // Nvidia Tablets
    ], [o, [a, ze], [t, x]], [/(sprint) (\w+)/i
    // Sprint Phones
    ], [a, o, [t, h]], [/(kin\.[onetw]{3})/i
    // Microsoft Kin
    ], [[o, /\./g, " "], [a, Te], [t, h]], [/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
    // Zebra
    ], [o, [a, Me], [t, x]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [o, [a, Me], [t, h]], [
    ///////////////////
    // SMARTTVS
    ///////////////////
    /smart-tv.+(samsung)/i
    // Samsung
    ], [a, [t, k]], [/hbbtv.+maple;(\d+)/i], [[o, /^/, "SmartTV"], [a, se], [t, k]], [/tcast.+(lg)e?. ([-\w]+)/i
    // LG SmartTV
    ], [a, o, [t, k]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[a, ye], [t, k]], [/(apple) ?tv/i
    // Apple TV
    ], [a, [o, J + " TV"], [t, k]], [/crkey.*devicetype\/chromecast/i
    // Google Chromecast Third Generation
    ], [[o, q + " Third Generation"], [a, Y], [t, k]], [/crkey.*devicetype\/([^/]*)/i
    // Google Chromecast with specific device type
    ], [[o, /^/, "Chromecast "], [a, Y], [t, k]], [/fuchsia.*crkey/i
    // Google Chromecast Nest Hub
    ], [[o, q + " Nest Hub"], [a, Y], [t, k]], [/crkey/i
    // Google Chromecast, Linux-based or unknown
    ], [[o, q], [a, Y], [t, k]], [/(portaltv)/i
    // Facebook Portal TV
    ], [o, [a, Pe], [t, k]], [/droid.+aft(\w+)( bui|\))/i
    // Fire TV
    ], [o, [a, xe], [t, k]], [/(shield \w+ tv)/i
    // Nvidia Shield TV
    ], [o, [a, ze], [t, k]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i
    // Sharp
    ], [o, [a, oi], [t, k]], [/(bravia[\w ]+)( bui|\))/i
    // Sony
    ], [o, [a, le], [t, k]], [/(mi(tv|box)-?\w+) bui/i
    // Xiaomi
    ], [o, [a, Ie], [t, k]], [/Hbbtv.*(technisat) (.*);/i
    // TechniSAT
    ], [a, o, [t, k]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
    // Roku
    /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
    // HbbTV devices
    ], [[a, ge], [o, ge], [t, k]], [
    // SmartTV from Unidentified Vendors
    /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i], [o, [t, k]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[t, k]], [
    ///////////////////
    // CONSOLES
    ///////////////////
    /(ouya)/i,
    // Ouya
    /(nintendo) (\w+)/i
    // Nintendo
    ], [a, o, [t, ue]], [/droid.+; (shield)( bui|\))/i
    // Nvidia Portable
    ], [o, [a, ze], [t, ue]], [/(playstation \w+)/i
    // Playstation
    ], [o, [a, le], [t, ue]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i
    // Microsoft Xbox
    ], [o, [a, Te], [t, ue]], [
    ///////////////////
    // WEARABLES
    ///////////////////
    /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
    // Samsung Galaxy Watch
    ], [o, [a, se], [t, B]], [/((pebble))app/i,
    // Pebble
    /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
    // Asus ZenWatch / LG Watch / Pixel Watch
    ], [a, o, [t, B]], [/(ow(?:19|20)?we?[1-3]{1,3})/i
    // Oppo Watch
    ], [o, [a, He], [t, B]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
    // Apple Watch
    ], [o, [a, J], [t, B]], [/(opwwe\d{3})/i
    // OnePlus Watch
    ], [o, [a, ti], [t, B]], [/(moto 360)/i
    // Motorola 360
    ], [o, [a, _e], [t, B]], [/(smartwatch 3)/i
    // Sony SmartWatch
    ], [o, [a, le], [t, B]], [/(g watch r)/i
    // LG G Watch R
    ], [o, [a, ye], [t, B]], [/droid.+; (wt63?0{2,3})\)/i], [o, [a, Me], [t, B]], [
    ///////////////////
    // XR
    ///////////////////
    /droid.+; (glass) \d/i
    // Google Glass
    ], [o, [a, Y], [t, Le]], [/(pico) (4|neo3(?: link|pro)?)/i
    // Pico
    ], [a, o, [t, Le]], [/(quest( \d| pro)?s?).+vr/i
    // Meta Quest
    ], [o, [a, Pe], [t, Le]], [
    ///////////////////
    // EMBEDDED
    ///////////////////
    /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
    // Tesla
    ], [a, [t, pe]], [/(aeobc)\b/i
    // Echo Dot
    ], [o, [a, xe], [t, pe]], [/(homepod).+mac os/i
    // Apple HomePod
    ], [o, [a, J], [t, pe]], [/windows iot/i], [[t, pe]], [
    ////////////////////
    // MIXED (GENERIC)
    ///////////////////
    /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i], [o, [t, G, {
      mobile: "Mobile",
      xr: "VR",
      "*": x
    }]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
    // Unidentifiable Tablet
    ], [[t, x]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
    // Unidentifiable Mobile
    ], [[t, h]], [/droid .+?; ([\w\. -]+)( bui|\))/i
    // Generic Android Device
    ], [o, [a, "Generic"]]],
    engine: [[/windows.+ edge\/([\w\.]+)/i
    // EdgeHTML
    ], [s, [n, ji + "HTML"]], [/(arkweb)\/([\w\.]+)/i
    // ArkWeb
    ], [n, s], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
    // Blink
    ], [s, [n, "Blink"]], [/(presto)\/([\w\.]+)/i,
    // Presto
    /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
    // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
    /ekioh(flow)\/([\w\.]+)/i,
    // Flow
    /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
    // KHTML/Tasman/Links
    /(icab)[\/ ]([23]\.[\d\.]+)/i,
    // iCab
    /\b(libweb)/i
    // LibWeb
    ], [n, s], [/ladybird\//i], [[n, "LibWeb"]], [/rv\:([\w\.]{1,9})\b.+(gecko)/i
    // Gecko
    ], [s, n]],
    os: [[
    // Windows
    /microsoft (windows) (vista|xp)/i
    // Windows (iTunes)
    ], [n, s], [/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
    // Windows Phone
    ], [n, [s, G, si]], [/windows nt 6\.2; (arm)/i,
    // Windows RT
    /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[s, G, si], [n, $e]], [
    // iOS/macOS
    /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
    // iOS
    /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[s, /_/g, "."], [n, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i
    // Mac OS
    ], [[n, "macOS"], [s, /_/g, "."]], [
    // Google Chromecast
    /android ([\d\.]+).*crkey/i
    // Google Chromecast, Android-based
    ], [s, [n, q + " Android"]], [/fuchsia.*crkey\/([\d\.]+)/i
    // Google Chromecast, Fuchsia-based
    ], [s, [n, q + " Fuchsia"]], [/crkey\/([\d\.]+).*devicetype\/smartspeaker/i
    // Google Chromecast, Linux-based Smart Speaker
    ], [s, [n, q + " SmartSpeaker"]], [/linux.*crkey\/([\d\.]+)/i
    // Google Chromecast, Legacy Linux-based
    ], [s, [n, q + " Linux"]], [/crkey\/([\d\.]+)/i
    // Google Chromecast, unknown
    ], [s, [n, q]], [
    // Mobile OSes
    /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
    // Android-x86/HarmonyOS
    ], [s, n], [/(ubuntu) ([\w\.]+) like android/i
    // Ubuntu Touch
    ], [[n, /(.+)/, "$1 Touch"], s], [
    // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
    /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/\.; ]?([\d\.]*)/i], [n, s], [/\(bb(10);/i
    // BlackBerry 10
    ], [s, [n, Je]], [/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
    // Symbian
    ], [s, [n, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
    // Firefox OS
    ], [s, [n, fe + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
    // WebOS
    ], [s, [n, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
    // watchOS
    ], [s, [n, "watchOS"]], [
    // Google ChromeOS
    /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
    // Chromium OS
    ], [[n, "Chrome OS"], s], [
    // Smart TVs
    /panasonic;(viera)/i,
    // Panasonic Viera
    /(netrange)mmh/i,
    // Netrange
    /(nettv)\/(\d+\.[\w\.]+)/i,
    // NetTV
    // Console
    /(nintendo|playstation) (\w+)/i,
    // Nintendo/Playstation
    /(xbox); +xbox ([^\);]+)/i,
    // Microsoft Xbox (360, One, X, S, Series X, Series S)
    /(pico) .+os([\w\.]+)/i,
    // Pico
    // Other
    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
    // Joli/Palm
    /(mint)[\/\(\) ]?(\w*)/i,
    // Mint
    /(mageia|vectorlinux)[; ]/i,
    // Mageia/VectorLinux
    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
    // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
    /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
    // Hurd/Linux
    /(gnu) ?([\w\.]*)/i,
    // GNU
    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
    // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
    /(haiku) (\w+)/i
    // Haiku
    ], [n, s], [/(sunos) ?([\w\.\d]*)/i
    // Solaris
    ], [[n, "Solaris"], s], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
    // Solaris
    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
    // AIX
    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
    // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
    /(unix) ?([\w\.]*)/i
    // UNIX
    ], [n, s]]
  },
  ve = function () {
    var e = {
      init: {},
      isIgnore: {},
      isIgnoreRgx: {},
      toString: {}
    };
    return N.call(e.init, [[R, [n, s, we, t]], [F, [E]], [D, [t, o, a]], [M, [n, s]], [z, [n, s]]]), N.call(e.isIgnore, [[R, [s, we]], [M, [s]], [z, [s]]]), N.call(e.isIgnoreRgx, [[R, / ?browser$/i], [z, / ?os$/i]]), N.call(e.toString, [[R, [n, s]], [F, [E]], [D, [a, o]], [M, [n, s]], [z, [n, s]]]), e;
  }(),
  Gi = function Gi(e, i) {
    var r = ve.init[i],
      d = ve.isIgnore[i] || 0,
      f = ve.isIgnoreRgx[i] || 0,
      u = ve.toString[i] || 0;
    function l() {
      N.call(this, r);
    }
    return l.prototype.getItem = function () {
      return e;
    }, l.prototype.withClientHints = function () {
      return V ? V.getHighEntropyValues(hi).then(function (w) {
        return e.setCH(new wi(w, !1)).parseCH().get();
      }) : e.parseCH().get();
    }, l.prototype.withFeatureCheck = function () {
      return e.detectFeature().get();
    }, i != ee && (l.prototype.is = function (w) {
      var b = !1;
      for (var c in this) {
        if (this.hasOwnProperty(c) && !je(d, c) && U(f ? ae(f, this[c]) : this[c]) == U(f ? ae(f, w) : w)) {
          if (b = !0, w != W) break;
        } else if (w == W && b) {
          b = !b;
          break;
        }
      }
      return b;
    }, l.prototype.toString = function () {
      var w = te;
      for (var b in u) {
        typeof this[u[b]] !== W && (w += (w ? " " : te) + this[u[b]]);
      }
      return w || W;
    }), V || (l.prototype.then = function (w) {
      var b = this,
        c = function c() {
          for (var y in b) {
            b.hasOwnProperty(y) && (this[y] = b[y]);
          }
        };
      c.prototype = {
        is: l.prototype.is,
        toString: l.prototype.toString
      };
      var p = new c();
      return w(p), p;
    }), new l();
  };
function wi(e, i) {
  if (e = e || {}, N.call(this, hi), i) N.call(this, [[qe, Be(e[X])], [Ve, Be(e[Pi])], [h, /\?1/.test(e[Ui])], [o, be(e[Ni])], [ie, be(e[pi])], [Ge, be(e[$i])], [E, be(e[Bi])], [K, Be(e[Fi])], [Ae, be(e[Di])]]);else for (var r in e) {
    this.hasOwnProperty(r) && typeof e[r] !== W && (this[r] = e[r]);
  }
}
function di(e, i, r, d) {
  return this.get = function (f) {
    return f ? this.data.hasOwnProperty(f) ? this.data[f] : void 0 : this.data;
  }, this.set = function (f, u) {
    return this.data[f] = u, this;
  }, this.setCH = function (f) {
    return this.uaCH = f, this;
  }, this.detectFeature = function () {
    if (A && A.userAgent == this.ua) switch (this.itemType) {
      case R:
        A.brave && typeof A.brave.isBrave == Re && this.set(n, "Brave");
        break;
      case D:
        !this.get(t) && V && V[h] && this.set(t, h), this.get(o) == "Macintosh" && A && typeof A.standalone !== W && A.maxTouchPoints && A.maxTouchPoints > 2 && this.set(o, "iPad").set(t, x);
        break;
      case z:
        !this.get(n) && V && V[ie] && this.set(n, V[ie]);
        break;
      case ee:
        var f = this.data,
          u = function u(l) {
            return f[l].getItem().detectFeature().get();
          };
        this.set(R, u(R)).set(F, u(F)).set(D, u(D)).set(M, u(M)).set(z, u(z));
    }
    return this;
  }, this.parseUA = function () {
    return this.itemType != ee && Fe.call(this.data, this.ua, this.rgxMap), this.itemType == R && this.set(we, De(this.get(s))), this;
  }, this.parseCH = function () {
    var f = this.uaCH,
      u = this.rgxMap;
    switch (this.itemType) {
      case R:
      case M:
        var l = f[Ve] || f[qe],
          w;
        if (l) for (var b in l) {
          var c = l[b].brand || l[b],
            p = l[b].version;
          this.itemType == R && !/not.a.brand/i.test(c) && (!w || /chrom/i.test(w) && c != ni) && (c = G(c, {
            Chrome: "Google Chrome",
            Edge: "Microsoft Edge",
            "Chrome WebView": "Android WebView",
            "Chrome Headless": "HeadlessChrome",
            "Huawei Browser": "HuaweiBrowser",
            "MIUI Browser": "Miui Browser",
            "Opera Mobi": "OperaMobile",
            Yandex: "YaBrowser"
          }), this.set(n, c).set(s, p).set(we, De(p)), w = c), this.itemType == M && c == ni && this.set(s, p);
        }
        break;
      case F:
        var y = f[E];
        y && (y && f[Ae] == "64" && (y += "64"), Fe.call(this.data, y + ";", u));
        break;
      case D:
        if (f[h] && this.set(t, h), f[o] && (this.set(o, f[o]), !this.get(t) || !this.get(a))) {
          var g = {};
          Fe.call(g, "droid 9; " + f[o] + ")", u), !this.get(t) && g.type && this.set(t, g.type), !this.get(a) && g.vendor && this.set(a, g.vendor);
        }
        if (f[K]) {
          var v;
          if (typeof f[K] != "string") for (var P = 0; !v && P < f[K].length;) {
            v = G(f[K][P++], li);
          } else v = G(f[K], li);
          this.set(t, v);
        }
        break;
      case z:
        var C = f[ie];
        if (C) {
          var L = f[Ge];
          C == $e && (L = parseInt(De(L), 10) >= 13 ? "11" : "10"), this.set(n, C).set(s, L);
        }
        this.get(n) == $e && f[o] == "Xbox" && this.set(n, "Xbox").set(s, void 0);
        break;
      case ee:
        var j = this.data,
          I = function I(T) {
            return j[T].getItem().setCH(f).parseCH().get();
          };
        this.set(R, I(R)).set(F, I(F)).set(D, I(D)).set(M, I(M)).set(z, I(z));
    }
    return this;
  }, N.call(this, [["itemType", e], ["ua", i], ["uaCH", d], ["rgxMap", r], ["data", Gi(this, e)]]), this;
}
function $(e, i, r) {
  if (typeof e === oe ? (Ee(e, !0) ? (typeof i === oe && (r = i), i = e) : (r = e, i = void 0), e = void 0) : typeof e === Ne && !Ee(i, !0) && (r = i, i = void 0), r && typeof r.append === Re) {
    var d = {};
    r.forEach(function (b, c) {
      d[c] = b;
    }), r = d;
  }
  if (!(this instanceof $)) return new $(e, i, r).getResult();
  var f = typeof e === Ne ? e :
    // Passed user-agent string
    r && r[Ye] ? r[Ye] :
    // User-Agent from passed headers
    A && A.userAgent ? A.userAgent :
    // navigator.userAgent
    te,
    u = new wi(r, !0),
    l = i ? Vi(fi, i) : fi,
    w = function w(b) {
      return b == ee ? function () {
        return new di(b, f, l, u).set("ua", f).set(R, this.getBrowser()).set(F, this.getCPU()).set(D, this.getDevice()).set(M, this.getEngine()).set(z, this.getOS()).get();
      } : function () {
        return new di(b, f, l[b], u).parseUA().get();
      };
    };
  return N.call(this, [["getBrowser", w(R)], ["getCPU", w(F)], ["getDevice", w(D)], ["getEngine", w(M)], ["getOS", w(z)], ["getResult", w(ee)], ["getUA", function () {
    return f;
  }], ["setUA", function (b) {
    return ne(b) && (f = b.length > Ue ? ge(b, Ue) : b), this;
  }]]).setUA(f), this;
}
$.VERSION = Mi;
$.BROWSER = Oe([n, s, we, t]);
$.CPU = Oe([E]);
$.DEVICE = Oe([o, a, t, ue, h, k, x, B, pe]);
$.ENGINE = $.OS = Oe([n, s]);
var Wi = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var _yield$Ki, i, r;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!Xi()) {
                _context.next = 3;
                break;
              }
              window.location.href = e;
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return Ki(e);
            case 5:
              _yield$Ki = _context.sent;
              i = _yield$Ki.content;
              r = _yield$Ki.reportName;
              return _context.abrupt("return", (Ii.saveAs(i, r), {
                content: i,
                reportName: r
              }));
            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function Wi(_x) {
      return _ref.apply(this, arguments);
    };
  }(),
  Xi = function Xi() {
    var e = new $(),
      i = e.getOS(),
      r = e.getDevice();
    return Yi(r, i);
  },
  Yi = function Yi(e, i) {
    var d, f;
    var r = +(((d = i.version) == null ? void 0 : d.split(".")[0]) || 0);
    return e.type === "mobile" && ((f = i.name) == null ? void 0 : f.toLowerCase()) === "ios" && r <= 12;
  },
  Ki = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var i,
        l,
        r,
        d,
        f,
        b,
        c,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              i = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "report.pdf";
              _context2.next = 3;
              return fetch(e, {
                headers: {
                  "Content-Type": "application/pdf"
                }
              });
            case 3:
              r = _context2.sent;
              if (!(r.status === 404)) {
                _context2.next = 6;
                break;
              }
              throw new Error("Not Found");
            case 6:
              d = i;
              f = r.headers.get("Content-disposition") || "";
              if (f) {
                b = f.split(";").find(function (c) {
                  return c.trim().startsWith("filename");
                });
                if (b) {
                  c = (l = b.split("=")[1]) == null ? void 0 : l.trim().replace("utf-8''", "").replace(/['"]/g, "");
                  d = decodeURIComponent(c);
                }
              }
              _context2.next = 11;
              return r.blob();
            case 11:
              _context2.t0 = _context2.sent;
              _context2.t1 = d;
              return _context2.abrupt("return", {
                content: _context2.t0,
                reportName: _context2.t1
              });
            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function Ki(_x2) {
      return _ref2.apply(this, arguments);
    };
  }(),
  gi = {
    button: {
      color: {
        primary: {
          accent: {
            bg: {
              color: {
                default: "#00a6ee",
                hover: "#0091df",
                focus: "#0091df",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "#0060e1",
                hover: "#004bd6",
                focus: "#004bd6",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "#8131cc",
                hover: "#6f00c4",
                focus: "#6f00c4",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            }
          }
        },
        secondary: {
          accent: {
            bg: {
              color: {
                default: "#daf4ff",
                hover: "#b7e8ff",
                focus: "#b7e8ff",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#ffffff"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "#e4f0ff",
                hover: "#cee1ff",
                focus: "#cee1ff",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#ffffff"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "#f8edff",
                hover: "#f0dbfe",
                focus: "#f0dbfe",
                disabled: "#bfc7d1"
              }
            },
            label: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#ffffff"
              }
            },
            icon: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#ffffff"
              }
            }
          }
        },
        text: {
          accent: {
            bg: {
              color: {
                default: "rgba(255, 255, 255, 0)",
                hover: "rgba(255, 255, 255, 0)",
                focus: "rgba(255, 255, 255, 0)",
                disabled: "rgba(255, 255, 255, 0)"
              }
            },
            label: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "rgba(255, 255, 255, 0)",
                hover: "rgba(255, 255, 255, 0)",
                focus: "rgba(255, 255, 255, 0)",
                disabled: "rgba(255, 255, 255, 0)"
              }
            },
            label: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "rgba(255, 255, 255, 0)",
                hover: "rgba(255, 255, 255, 0)",
                focus: "rgba(255, 255, 255, 0)",
                disabled: "rgba(255, 255, 255, 0)"
              }
            },
            label: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            }
          }
        },
        inverse: {
          accent: {
            bg: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            label: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#0091df",
                hover: "#005fab",
                focus: "#005fab",
                disabled: "#a2acb7"
              }
            }
          },
          accentContrast: {
            bg: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            label: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#004bd6",
                hover: "#0028ad",
                focus: "#0028ad",
                disabled: "#a2acb7"
              }
            }
          },
          alternative: {
            bg: {
              color: {
                default: "#ffffff",
                hover: "#ffffff",
                focus: "#ffffff",
                disabled: "#ffffff"
              }
            },
            label: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            },
            icon: {
              color: {
                default: "#6f00c4",
                hover: "#4a008c",
                focus: "#4a008c",
                disabled: "#a2acb7"
              }
            }
          }
        }
      }
    },
    focus: {
      accent: {
        color: "#74cfff"
      },
      accentContrast: {
        color: "#4790f9"
      },
      alternative: {
        color: "#b573ec"
      }
    }
  },
  Zi = {
    button: {
      size: {
        xl: {
          variant: {
            primary: {
              borderRadius: "12px",
              height: "64px",
              paddingLeft: "40px",
              paddingRight: "40px"
            },
            secondary: {
              borderRadius: "12px",
              height: "64px",
              paddingLeft: "40px",
              paddingRight: "40px"
            },
            inverse: {
              borderRadius: "12px",
              height: "64px",
              paddingLeft: "40px",
              paddingRight: "40px"
            },
            text: {
              borderRadius: "3px",
              height: "32px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "8px",
            icon: {
              width: "32px",
              height: "32px"
            }
          }
        },
        l: {
          variant: {
            primary: {
              borderRadius: "8px",
              height: "56px",
              paddingLeft: "32px",
              paddingRight: "32px"
            },
            secondary: {
              borderRadius: "8px",
              height: "56px",
              paddingLeft: "32px",
              paddingRight: "32px"
            },
            inverse: {
              borderRadius: "8px",
              height: "56px",
              paddingLeft: "32px",
              paddingRight: "32px"
            },
            text: {
              borderRadius: "3px",
              height: "26px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "8px",
            icon: {
              width: "26px",
              height: "26px"
            }
          }
        },
        m: {
          variant: {
            primary: {
              borderRadius: "8px",
              height: "48px",
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            secondary: {
              borderRadius: "8px",
              height: "48px",
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            inverse: {
              borderRadius: "8px",
              height: "48px",
              paddingLeft: "24px",
              paddingRight: "24px"
            },
            text: {
              borderRadius: "3px",
              height: "24px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "8px",
            icon: {
              width: "24px",
              height: "24px"
            }
          }
        },
        s: {
          variant: {
            primary: {
              borderRadius: "6px",
              height: "40px",
              paddingLeft: "20px",
              paddingRight: "20px"
            },
            secondary: {
              borderRadius: "6px",
              height: "40px",
              paddingLeft: "20px",
              paddingRight: "20px"
            },
            inverse: {
              borderRadius: "6px",
              height: "40px",
              paddingLeft: "20px",
              paddingRight: "20px"
            },
            text: {
              borderRadius: "3px",
              height: "16px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "4px",
            icon: {
              width: "16px",
              height: "16px"
            }
          }
        },
        xs: {
          variant: {
            primary: {
              borderRadius: "6px",
              height: "32px",
              paddingLeft: "16px",
              paddingRight: "16px"
            },
            secondary: {
              borderRadius: "6px",
              height: "32px",
              paddingLeft: "16px",
              paddingRight: "16px"
            },
            inverse: {
              borderRadius: "6px",
              height: "32px",
              paddingLeft: "16px",
              paddingRight: "16px"
            },
            text: {
              borderRadius: "3px",
              height: "12px",
              paddingLeft: "0",
              paddingRight: "0"
            }
          },
          common: {
            spacing: "4px",
            icon: {
              width: "12px",
              height: "12px"
            }
          }
        }
      }
    }
  },
  mi = {
    font: {
      family: {
        base: "'Noto Sans', Arial, sans-serif"
      }
    },
    button: {
      font: {
        size: {
          xl: {
            label: {
              fontSize: "20px",
              lineHeight: "32px"
            }
          },
          l: {
            label: {
              fontSize: "18px",
              lineHeight: "24px"
            }
          },
          m: {
            label: {
              fontSize: "16px",
              lineHeight: "24px"
            }
          },
          s: {
            label: {
              fontSize: "14px",
              lineHeight: "22px"
            }
          },
          xs: {
            label: {
              fontSize: "12px",
              lineHeight: "16px"
            }
          }
        },
        common: {
          label: {
            fontFamily: "'Noto Sans', Arial, sans-serif",
            fontWeight: "700",
            letterSpacing: "0"
          }
        }
      }
    }
  },
  Ji = {
    blue99: "#f3fdff",
    blue95: "#daf4ff",
    blue90: "#b7e8ff",
    blue80: "#74cfff",
    blue70: "#18b7f7",
    blue60: "#00a6ee",
    blue40: "#0078c1",
    blue50: "#0091df",
    blue30: "#005fab",
    blue20: "#00478c",
    blue10: "#00366c",
    darkBlue99: "#f7fcff",
    darkBlue95: "#e4f0ff",
    darkBlue90: "#cee1ff",
    darkBlue80: "#a8c5ff",
    darkBlue70: "#7daaff",
    darkBlue60: "#4790f9",
    darkBlue50: "#0077ed",
    darkBlue40: "#0060e1",
    darkBlue30: "#004bd6",
    darkBlue20: "#0038c1",
    darkBlue10: "#0028ad",
    transparent: "rgba(255, 255, 255, 0)",
    black100: "#ffffff",
    black99: "#f8f9fa",
    black95: "#eef1f4",
    black90: "#dde3ea",
    black80: "#bfc7d1",
    black70: "#a2acb7",
    black60: "#87929e",
    black50: "#6c7886",
    black40: "#52606e",
    black30: "#394857",
    black20: "#213241",
    black10: "#081d2d",
    green99: "#d1ffe6",
    green95: "#99f7c4",
    green90: "#7cecb0",
    green80: "#59d994",
    green70: "#4ac684",
    green60: "#33b36e",
    green50: "#289f5e",
    green40: "#268b54",
    green30: "#11703c",
    green20: "#065128",
    green10: "#00381a",
    yellow99: "#fffad5",
    yellow95: "#ffec8f",
    yellow90: "#ffdd6d",
    yellow80: "#ffd240",
    yellow70: "#ffc710",
    yellow60: "#ffa903",
    yellow50: "#f4890a",
    yellow40: "#e16105",
    yellow30: "#ac4a03",
    yellow20: "#7a3503",
    yellow10: "#4e2202",
    red99: "#fff6f9",
    red95: "#ffe3eb",
    red90: "#ffcedb",
    red80: "#ffaabc",
    red70: "#ff859f",
    red60: "#f05e83",
    red50: "#de2d68",
    red40: "#cb004e",
    red30: "#b60041",
    red20: "#9a0034",
    red10: "#7f0020",
    purple99: "#fefbff",
    purple95: "#f8edff",
    purple90: "#f0dbfe",
    purple80: "#e0b7fd",
    purple70: "#cd93fb",
    purple60: "#b573ec",
    purple50: "#9b53dc",
    purple40: "#8131cc",
    purple30: "#6f00c4",
    purple20: "#5a00a4",
    purple10: "#4a008c"
  },
  Qi = _objectSpread(_objectSpread({}, Ji), {}, {
    icon: "#0091DF"
  }),
  et = {
    size: {
      10: "10px",
      12: "12px",
      14: "14px",
      16: "16px",
      20: "20px",
      24: "24px",
      26: "26px",
      32: "32px",
      40: "40px",
      48: "48px"
    }
  },
  he = {
    desktop: "1440px",
    tablet: "1080px",
    tabletMd: "1024px",
    tabletSm: "768px",
    phone: "640px",
    phoneSm: "320px"
  },
  it = ["phoneSm", "phone", "tabletSm", "tabletMd", "tablet", "desktop"],
  tt = {
    name: "default",
    colors: Qi,
    icons: et,
    zIndex: {
      modal: 1080,
      tooltip: 999,
      datePicker: 959,
      toast: 9999,
      header: {
        overlay: 1060,
        menu: 1062,
        container: 1061
      },
      sticky: 1062
    },
    fontFamily: mi.font.family.base,
    up: function up(e) {
      return "@media (min-width: ".concat(he[e], ")");
    },
    down: function down(e) {
      return "@media (max-width: ".concat(he[e], ")");
    },
    between: function between(e, i) {
      return "@media (min-width: ".concat(he[e], ") and (max-width: ").concat(he[i], ")");
    }
  },
  ot = function ot(e, i) {
    return i in e.colors;
  },
  at = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
_i(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n  }\n\n  body {\n    min-width: ", ";\n  }\n\n  body,\n  button,\n  input {\n    font-family: ", ";\n    color: ", ";\n  }\n  p,\n  a,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  input,\n  hr,\n  button,\n  section,\n  menu {\n    margin: 0;\n    padding: 0;\n  }\n  div,\n  section,\n  input,\n  button {\n    box-sizing: border-box;\n  }\n  input {\n    outline: none;\n  }\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover,\n  textarea:-webkit-autofill:focus,\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus {\n    transition: background-color 100s ease-in-out 0s;\n  }\n  button {\n    border: none;\n  }\n"])), at, he.phoneSm, function (_ref3) {
  var e = _ref3.theme;
  return e.fontFamily;
}, function (_ref4) {
  var e = _ref4.theme;
  return e.colors.black10;
});
var nt = H.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
H.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
H.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
H.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
H(nt)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
H.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
H.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref5) {
  var e = _ref5.theme;
  return e.colors.red50;
});
S(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref6) {
  var e = _ref6.theme.down;
  return e("tablet");
});
var xi = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  yi = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  vi = "0px 4px 28px rgba(0, 0, 0, 0.14)";
S(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], xi);
S(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], yi);
S(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], vi);
S(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], xi);
S(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], yi);
S(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], vi);
H.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 0px;\n  padding: 0;\n  overflow: hidden;\n  position: fixed;\n  top: 1px;\n  left: 1px;\n"])));
var rt = S(["", ";g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{stroke:none;}*[fill-rule],*[FILL-RULE],*[fill*='#']:not([fill='#FFF']),*[FILL*='#']:not([FILL='#FFF']){fill:inherit;}"], function (_ref7) {
    var _i$colors$r;
    var e = _ref7.color,
      i = _ref7.theme,
      r = _ref7.disabled;
    var d;
    return r ? d = typeof r == "string" ? (_i$colors$r = i.colors[r]) !== null && _i$colors$r !== void 0 ? _i$colors$r : r : i.colors.black80 : e && ot(i, e) ? d = i.colors[e] : d = e || i.colors.icon, S(["fill:", ";stroke:", ";"], d, d);
  }),
  Se = 24,
  st = function st(e) {
    var i = e.match(/\d+(\.\d+)?/);
    return i ? parseFloat(i[0]) : Se;
  },
  lt = H.svg(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 0 0 auto;\n  ", "\n  ", ";\n"])), function (_ref8) {
    var _ref8$size = _ref8.size,
      e = _ref8$size === void 0 ? Se : _ref8$size,
      i = _ref8.theme,
      r = _ref8.viewBox;
    var _split = (r || "0 0 ".concat(Se, " ").concat(Se)).split(" "),
      _split2 = _slicedToArray(_split, 4),
      d = _split2[2],
      f = _split2[3],
      u = +d / +f,
      l = st(i.icons.size[e] || "".concat(e, "px"));
    return d < f ? "\n      width: ".concat(l, "px;\n      height: ").concat(l / u, "px;\n    ") : f < d ? "\n      width: ".concat(l * u, "px;\n      height: ").concat(l, "px;\n    ") : "\n      width: ".concat(l, "px;\n      height: ").concat(l, "px;\n    ");
  }, function (_ref9) {
    var e = _ref9.$hasOwnColorPattern;
    return e ? void 0 : rt;
  }),
  ki = function ki(_ref10) {
    var e = _ref10.a11yTitle,
      i = _objectWithoutProperties(_ref10, _excluded);
    return /* @__PURE__ */m(lt, _objectSpread(_objectSpread({}, i), {}, {
      name: e,
      "data-name": "hn-icon"
    }));
  },
  Si = function Si(e) {
    return /* @__PURE__ */m(ki, _objectSpread(_objectSpread({
      viewBox: "0 0 24 24",
      a11yTitle: "Download"
    }, e), {}, {
      children: /* @__PURE__ */m("path", {
        d: "M16.59 10.5H15V5.5C15 4.95 14.55 4.5 14 4.5H10C9.45 4.5 9 4.95 9 5.5V10.5H7.41C6.52 10.5 6.07 11.58 6.7 12.21L11.29 16.8C11.68 17.19 12.31 17.19 12.7 16.8L17.29 12.21C17.92 11.58 17.48 10.5 16.59 10.5ZM3 20.5C3 21.05 3.45 21.5 4 21.5H20C20.55 21.5 21 21.05 21 20.5C21 19.95 20.55 19.5 20 19.5H4C3.45 19.5 3 19.95 3 20.5Z",
        fill: "#0091DF"
      })
    }));
  };
Si.displayName = "Download";
var We = function We(e) {
  return /* @__PURE__ */ui(ki, _objectSpread(_objectSpread({
    viewBox: "0 0 100 100",
    a11yTitle: "Spinner"
  }, e), {}, {
    children: [/* @__PURE__ */m("g", {
      transform: "rotate(0 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.875s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */m("g", {
      transform: "rotate(45 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.75s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */m("g", {
      transform: "rotate(90 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.625s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */m("g", {
      transform: "rotate(135 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.5s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */m("g", {
      transform: "rotate(180 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.375s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */m("g", {
      transform: "rotate(225 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.25s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */m("g", {
      transform: "rotate(270 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "-0.125s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    }), /* @__PURE__ */m("g", {
      transform: "rotate(315 50 50)",
      style: {
        animationPlayState: "running",
        animationDelay: "0s"
      },
      children: /* @__PURE__ */m("rect", {
        x: "45.5",
        y: "7.5",
        rx: "2.31",
        ry: "2.31",
        width: "9",
        height: "21",
        fill: "#ffffff",
        style: {
          animationPlayState: "running",
          animationDelay: "0s"
        },
        children: /* @__PURE__ */m("animate", {
          attributeName: "opacity",
          values: "1;0",
          keyTimes: "0;1",
          dur: "1s",
          begin: "0s",
          repeatCount: "indefinite",
          style: {
            animationPlayState: "running",
            animationDelay: "0s"
          }
        })
      })
    })]
  }));
};
We.displayName = "Spinner";
var _ = gi.button.color,
  O = Zi.button.size,
  Z = mi.button.font,
  Ri = {
    xLarge: "xl",
    large: "l",
    medium: "m",
    small: "s",
    xSmall: "xs"
  },
  ft = function ft(e) {
    return Object.keys(Ri).includes(e);
  },
  dt = function dt(e) {
    return ft(e) ? Ri[e] : e;
  },
  ct = function ct(_ref11) {
    var e = _ref11.$variant,
      i = _ref11.$size;
    return S(["font-size:", ";line-height:", ";gap:", ";border-radius:", ";padding-left:", ";padding-right:", ";height:", ";[data-name='hn-icon']{width:", ";height:", ";}"], Z.size[i].label.fontSize, Z.size[i].label.lineHeight, O[i].common.spacing, O[i].variant[e].borderRadius, O[i].variant[e].paddingLeft, O[i].variant[e].paddingRight, O[i].variant[e].height, O[i].common.icon.width, O[i].common.icon.height);
  },
  bt = {
    desktop: "m",
    tablet: "m",
    tabletMd: "m",
    tabletSm: "s",
    phone: "s",
    phoneSm: "s"
  },
  ut = function ut(_ref12) {
    var e = _ref12.$variant;
    return S(["", " ", ""], ci(e, "phoneSm"), it.map(function (i) {
      return S(["", "{", "}"], tt.up(i), ci(e, i));
    }));
  },
  ci = function ci(e, i) {
    var r = bt[i];
    return S(["font-size:", ";line-height:", ";gap:", ";border-radius:", ";padding-left:", ";padding-right:", ";height:", ";[data-name='hn-icon']{width:", ";height:", ";}"], Z.size[r].label.fontSize, Z.size[r].label.lineHeight, O[r].common.spacing, O[r].variant[e].borderRadius, O[r].variant[e].paddingLeft, O[r].variant[e].paddingRight, O[r].variant[e].height, O[r].common.icon.width, O[r].common.icon.height);
  },
  pt = function pt(_ref13) {
    var e = _ref13.$variant,
      i = _ref13.$colorScheme;
    return S(["color:", ";background-color:", ";[data-name='hn-icon']{fill:", ";}&:focus-visible{outline:4px solid ", ";color:", ";background-color:", ";[data-name='hn-icon']{fill:", ";}}@media (hover:hover) and (pointer:fine){&:hover{background-color:", ";color:", ";[data-name='hn-icon']{fill:", ";}}}&:disabled{cursor:not-allowed;background-color:", ";color:", ";[data-name='hn-icon']{fill:", ";}}"], _[e][i].label.color.default, _[e][i].bg.color.default, _[e][i].label.color.default, gi.focus[i].color, _[e][i].label.color.focus, _[e][i].bg.color.focus, _[e][i].label.color.focus, _[e][i].bg.color.hover, _[e][i].label.color.hover, _[e][i].label.color.hover, _[e][i].bg.color.disabled, _[e][i].label.color.disabled, _[e][i].label.color.disabled);
  },
  ht = {
    content: "Please wait...",
    icon: We,
    blockEvents: !0
  },
  wt = H.button(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: fit-content;\n  height: fit-content;\n\n  border: none;\n  background-color: transparent;\n\n  cursor: pointer;\n  outline: none;\n  white-space: nowrap;\n  user-select: none;\n\n  font-family: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n\n  ", ";\n\n  ", ";\n\n  ", "\n"])), Z.common.label.fontFamily, Z.common.label.fontWeight, Z.common.label.letterSpacing, function (_ref14) {
    var e = _ref14.$adaptive,
      i = _ref14.$variant,
      r = _ref14.$colorScheme,
      d = _ref14.$size;
    return S(["", " ", ""], pt({
      $variant: i,
      $colorScheme: r
    }), e ? ut({
      $variant: i
    }) : ct({
      $variant: i,
      $size: d
    }));
  }, function (_ref15) {
    var e = _ref15.$fit;
    return e && S(["width:fit-content;"]);
  }, function (_ref16) {
    var e = _ref16.$wait;
    return e && S(["cursor:wait;"]);
  }),
  Ei = /*#__PURE__*/Oi(function (_ref17, I) {
    var _ref17$size = _ref17.size,
      e = _ref17$size === void 0 ? "m" : _ref17$size,
      _ref17$variant = _ref17.variant,
      i = _ref17$variant === void 0 ? "primary" : _ref17$variant,
      _ref17$colorScheme = _ref17.colorScheme,
      r = _ref17$colorScheme === void 0 ? "accent" : _ref17$colorScheme,
      _ref17$disabled = _ref17.disabled,
      d = _ref17$disabled === void 0 ? !1 : _ref17$disabled,
      f = _ref17.onClick,
      u = _ref17.children,
      l = _ref17.LeftIcon,
      w = _ref17.RightIcon,
      b = _ref17.tabIndex,
      _ref17$fit = _ref17.fit,
      c = _ref17$fit === void 0 ? !1 : _ref17$fit,
      p = _ref17.name,
      y = _ref17.value,
      g = _ref17.className,
      _ref17$type = _ref17.type,
      v = _ref17$type === void 0 ? "button" : _ref17$type,
      _ref17$waitingOptions = _ref17.waitingOptions,
      P = _ref17$waitingOptions === void 0 ? {} : _ref17$waitingOptions,
      _ref17$wait = _ref17.wait,
      C = _ref17$wait === void 0 ? !1 : _ref17$wait,
      _ref17$adaptive = _ref17.adaptive,
      L = _ref17$adaptive === void 0 ? !1 : _ref17$adaptive,
      j = _objectWithoutProperties(_ref17, _excluded2);
    var T = Ci(function () {
        var Ce = _objectSpread(_objectSpread({}, ht), P);
        return C ? {
          LeftIcon: Ce.icon,
          RightIcon: void 0,
          children: Ce.content,
          onClick: Ce.blockEvents ? void 0 : f
        } : {
          LeftIcon: l,
          RightIcon: w,
          children: u,
          onClick: f
        };
      }, [l, w, u, f, P, C]),
      Ai = dt(e);
    return /* @__PURE__ */ui(wt, _objectSpread(_objectSpread(_objectSpread({
      $size: Ai,
      $variant: i,
      $colorScheme: r,
      $wait: C,
      $adaptive: L,
      $fit: c,
      disabled: d,
      tabIndex: b,
      name: p,
      value: y,
      className: g,
      type: v,
      ref: I
    }, T), j), {}, {
      children: [/* @__PURE__ */m(bi, {
        Icon: T.LeftIcon
      }), T.children, /* @__PURE__ */m(bi, {
        Icon: T.RightIcon
      })]
    }));
  }),
  gt = H.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"]))),
  bi = function bi(_ref18) {
    var e = _ref18.Icon;
    return e ? /* @__PURE__ */m(gt, {
      children: /* @__PURE__ */m(e, {})
    }) : null;
  },
  mt = function mt(e) {
    return /* @__PURE__ */m(Ei, _objectSpread(_objectSpread({}, e), {}, {
      variant: "text",
      colorScheme: "accent"
    }));
  };
H(mt)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1;\n\n  ", ";\n"])), function (_ref19) {
  var e = _ref19.theme,
    i = _ref19.$danger;
  return i && S(["color:", ";&:hover,&:focus-visible{color:", ";}"], e.colors.red60, e.colors.red40);
});
var xt = function xt(_ref20) {
    var e = _ref20.apiUrl,
      _ref20$LeftIcon = _ref20.LeftIcon,
      i = _ref20$LeftIcon === void 0 ? Si : _ref20$LeftIcon,
      _ref20$SpinnerIcon = _ref20.SpinnerIcon,
      r = _ref20$SpinnerIcon === void 0 ? We : _ref20$SpinnerIcon,
      d = _ref20.onClick,
      f = _ref20.onError,
      u = _ref20.onFinishLoad,
      _ref20$fit = _ref20.fit,
      l = _ref20$fit === void 0 ? !0 : _ref20$fit,
      _ref20$variant = _ref20.variant,
      w = _ref20$variant === void 0 ? "primary" : _ref20$variant,
      _ref20$colorScheme = _ref20.colorScheme,
      b = _ref20$colorScheme === void 0 ? "accent" : _ref20$colorScheme,
      _ref20$size = _ref20.size,
      c = _ref20$size === void 0 ? "s" : _ref20$size,
      p = _ref20.children,
      _ref20$waitingOptions = _ref20.waitingOptions,
      y = _ref20$waitingOptions === void 0 ? {} : _ref20$waitingOptions,
      g = _objectWithoutProperties(_ref20, _excluded3);
    var _Li = Li(!1),
      _Li2 = _slicedToArray(_Li, 2),
      v = _Li2[0],
      P = _Li2[1],
      C = Ti( /*#__PURE__*/function () {
        var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(L) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  L.preventDefault(), P(!0), d == null || d(L);
                  _context3.prev = 1;
                  _context3.t0 = e;
                  if (!_context3.t0) {
                    _context3.next = 6;
                    break;
                  }
                  _context3.next = 6;
                  return Wi(e);
                case 6:
                  _context3.next = 11;
                  break;
                case 8:
                  _context3.prev = 8;
                  _context3.t1 = _context3["catch"](1);
                  f == null || f(_context3.t1.message);
                case 11:
                  _context3.prev = 11;
                  P(!1), u == null || u();
                  return _context3.finish(11);
                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[1, 8, 11, 14]]);
        }));
        return function (_x3) {
          return _ref21.apply(this, arguments);
        };
      }(), [e, d, f, u]);
    return /* @__PURE__ */m(Ei, _objectSpread(_objectSpread({
      variant: w,
      colorScheme: b,
      size: c,
      onClick: C,
      LeftIcon: i,
      "aria-pressed": v,
      fit: l,
      wait: v,
      waitingOptions: _objectSpread({
        icon: r,
        content: p,
        blockEvents: !0
      }, y)
    }, g), {}, {
      children: p
    }));
  },
  St = function St(e) {
    return /* @__PURE__ */m(xt, _objectSpread(_objectSpread({}, e), {}, {
      variant: "text",
      colorScheme: "accent"
    }));
  };
export { xt as PdfButton, St as PdfLinkButton };